import { Injectable, InjectionToken, inject } from '@angular/core';
import { init } from '@fullstory/browser';
import { ENVIRONMENT } from '../environment.token';

/** The SDK's `init`, behind a token so specs can assert on it without loading fs.js. */
export const FULLSTORY_INIT = new InjectionToken<typeof init>('FULLSTORY_INIT', {
  providedIn: 'root',
  factory: () => init,
});

/**
 * Starts Fullstory session recording.
 *
 * Called from an app initializer so fs.js is requested before the first render and can
 * capture it. Every environment shares one org; `devMode` makes the SDK shut down instead
 * of recording anywhere but production.
 * @see https://developer.fullstory.com/browser/
 */
@Injectable({ providedIn: 'root' })
export class FullstoryService {
  private readonly env = inject(ENVIRONMENT);
  private readonly fsInit = inject(FULLSTORY_INIT);

  initialize(): void {
    this.fsInit({
      orgId: this.env.fullstoryOrgId,
      devMode: !this.env.isProduction,
    });
  }
}
